import type { SortConfig } from "@/hooks/useSortable";

interface Props {
  label: string;
  sortKey: string;
  sortConfig: SortConfig;
  onSort: (key: string) => void;
}

export default function SortableHeader({ label, sortKey, sortConfig, onSort }: Props) {
  const isActive = sortConfig.key === sortKey;
  return (
    <th
      onClick={() => onSort(sortKey)}
      className="px-4 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400 cursor-pointer select-none hover:text-gray-700 dark:hover:text-gray-200"
    >
      <span className="inline-flex items-center gap-1">
        {label}
        {isActive ? (
          <span className="text-brand-500">{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
        ) : (
          <span className="text-gray-300 dark:text-gray-600">⇅</span>
        )}
      </span>
    </th>
  );
}
